import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

const serviceMappingSchema = z.object({
  carrier: z.string(),
  service: z.string().optional(),
  netsuiteShipItemId: z.string(),
});

const addressSchema = z.object({
  name: z.string().nullish(),
  address1: z.string().nullish(),
  address2: z.string().nullish(),
  company: z.string().nullish(),
  city: z.string().nullish(),
  province: z.string().nullish(),
  zip: z.string().nullish(),
  countryCode: z.string().nullish(),
  phone: z.string().nullish(),
  email: z.string().nullish(),
});

export const getOmsNetsuiteIntegration = {
  name: "getOmsNetsuiteIntegration" as const,
  input: z.object({}),
  output: z.object({
    integration: z
      .object({
        id: zExt.objectId(),
        accountId: z.string(),
        settings: z.object({
          syncIncomingOrders: z.boolean(),
          sendUpdates: z.boolean(),
          serviceMappings: z.array(serviceMappingSchema).nullish(),
          defaultShipItemId: z.string().nullish(),
          shippingCostField: z.string().nullish(),
          fallbackAddress: addressSchema.nullish(),
          customSkuField: z.string().nullish(),
          secondaryOrderNameField: z.string().nullish(),
        }),
      })
      .nullable(),
  }),
};
